/*
 * Copyright (c) 2021-2024. StockAnywhere CC
 * StockAnywhere - https://www.stockanywhere.io
 * View license agreement and terms of use at https://www.stockanywhere.io/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2024-09-12
 */

import React, { useEffect, useRef } from "react";

// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core';

export interface IQueryChart {
    option: any;
}

export const QueryChart: React.FC<IQueryChart> = (props) => {

    const chartRef = useRef<HTMLDivElement>(null);
    let chartInstance: echarts.ECharts | null = null;

    // const option = {
    //     title: {
    //         text: 'Best Sellers 2024'
    //     },        
    //     legend: {},
    //     tooltip: {
    //       trigger: 'axis',
    //       showContent: false
    //     },
    //     dataset: {
    //       source: [
    //         ['product', '2012', '2013', '2014', '2015', '2016', '2017'],
    //         ['Milk Tea', 56.5, 82.1, 88.7, 70.1, 53.4, 85.1],
    //         ['Matcha Latte', 51.1, 51.4, 55.1, 53.3, 73.8, 68.7],
    //         ['Cheese Cocoa', 40.1, 62.2, 69.5, 36.4, 45.2, 32.5],
    //         ['Walnut Brownie', 25.2, 37.1, 41.2, 18, 33.9, 49.1]
    //       ]
    //     },
    //     xAxis: { type: 'category' },
    //     yAxis: { gridIndex: 0 },
    //     grid: { top: '55%' },
    //     series: [
    //       {
    //         type: 'line',
    //         smooth: true,
    //         seriesLayoutBy: 'row',
    //         emphasis: { focus: 'series' }
    //       },
    //       {
    //         type: 'line',
    //         smooth: true,
    //         seriesLayoutBy: 'row',
    //         emphasis: { focus: 'series' }
    //       },
    //       {
    //         type: 'line',
    //         smooth: true,
    //         seriesLayoutBy: 'row',
    //         emphasis: { focus: 'series' }
    //       },
    //       {
    //         type: 'line',
    //         smooth: true,
    //         seriesLayoutBy: 'row',
    //         emphasis: { focus: 'series' }
    //       },
    //       {
    //         type: 'pie',
    //         id: 'pie',
    //         radius: '30%',
    //         center: ['50%', '25%'],
    //         emphasis: {
    //           focus: 'self'
    //         },
    //         label: {
    //           formatter: '{b}: {@2012} ({d}%)'
    //         },
    //         encode: {
    //           itemName: 'product',
    //           value: '2012',
    //           tooltip: '2012'
    //         }
    //       }
    //     ]
    // };

    useEffect(() => {



        if (chartRef.current) {
            // Initialize the chart on the DOM element
            chartInstance = echarts.init(chartRef.current);

            // chartInstance.setOption({
            //     title: {
            //         text: 'Best Sellers 2024'
            //     },
            //     tooltip: {},
            //     xAxis: {
            //         data: ['shirt', 'cardigan', 'chiffon', 'pants', 'heels', 'socks']
            //     },
            //     yAxis: {},
            //     series: [
            //     {
            //         name: 'sales',
            //         type: 'bar',
            //         data: [5, 20, 36, 10, 10, 20]
            //     }
            //     ]
            // });

            chartInstance.on('updateAxisPointer', function (event: any) {
                const xAxisInfo = event.axesInfo[0];
                if (xAxisInfo) {
                  const dimension = xAxisInfo.value + 1;
                  chartInstance?.setOption({
                    series: {
                      id: 'pie',
                      label: {
                        formatter: '{b}: {@[' + dimension + ']} ({d}%)'
                      },
                      encode: {
                        value: dimension,
                        tooltip: dimension
                      }
                    }
                  });
                }
              });
            
              chartInstance.setOption(props.option);

        }

    }, []);

    return (
        <>
            <div ref={chartRef} id="main" style={{width: "600px",  height:"400px"}}></div>
        </>
    );
}